// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum EtapaEnum {
  Fabricacion = 1,
  Transporte = 2,
  Extendido = 3,
  Retorno = 4
}
